export default "__VITE_ASSET__Dcnvsq1G__"